<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-button
          variant="link"
          class="px-0 mb-3"
          @click="$router.push('/ead/quizzes')"
        >
          <i class="fa fa-arrow-left mr-2"></i>
          Voltar para Quizzes
        </b-button>
        <h2 class="mb-4">{{ quiz ? quiz.title : "Carregando..." }}</h2>
      </b-col>
    </b-row>

    <div v-if="loading" class="text-center py-5">
      <b-spinner></b-spinner>
    </div>

    <div v-else-if="quiz">
      <b-card no-body>
        <b-tabs card>
          <!-- Tab 1: Informações -->
          <b-tab title="Informações" active>
            <b-form @submit.prevent="saveQuiz">
              <b-form-group label="Título">
                <b-form-input v-model="quizForm.title" required></b-form-input>
              </b-form-group>
              <b-form-group label="Descrição">
                <b-form-textarea
                  v-model="quizForm.description"
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Nota Mínima (%)">
                    <b-form-input
                      v-model.number="quizForm.passingScore"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Tempo (min)">
                    <b-form-input
                      v-model.number="timeInMinutes"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-checkbox v-model="quizForm.shuffleQuestions" switch
                >Embaralhar perguntas</b-form-checkbox
              >
              <b-form-checkbox v-model="quizForm.showResultsImmediately" switch
                >Mostrar resultado</b-form-checkbox
              >
              <hr />
              <b-button type="submit" variant="primary"
                ><i class="fa fa-save mr-1"></i>Salvar</b-button
              >
            </b-form>
          </b-tab>

          <!-- Tab 2: Perguntas -->
          <b-tab title="Perguntas">
            <div class="mb-3">
              <b-button
                size="sm"
                variant="success"
                @click="openQuestionModal()"
              >
                <i class="fa fa-plus mr-1"></i>Nova Pergunta
              </b-button>
            </div>

            <div v-if="questions.length === 0" class="text-center py-5">
              <i class="fa fa-question-circle fa-3x text-muted"></i>
              <p class="mt-3">Nenhuma pergunta adicionada</p>
            </div>

            <div
              v-else
              v-for="(q, index) in questions"
              :key="index"
              class="question-card mb-3"
            >
              <div class="question-header">
                <b-badge variant="primary" class="mr-2">{{
                  index + 1
                }}</b-badge>
                <strong>{{ q.question }}</strong>
                <div class="ml-auto">
                  <b-button
                    size="sm"
                    variant="link"
                    @click="openQuestionModal(index)"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button
                    size="sm"
                    variant="link"
                    class="text-danger"
                    @click="deleteQuestion(index)"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </div>
              <div class="question-body">
                <div v-for="(opt, i) in q.options" :key="i" class="option-item">
                  <i
                    :class="
                      opt.isCorrect
                        ? 'fa fa-check-circle text-success'
                        : 'fa fa-circle-o'
                    "
                  ></i>
                  {{ opt.label }}. {{ opt.text }}
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>

    <!-- Modal Pergunta -->
    <b-modal
      v-model="questionModal"
      title="Pergunta"
      size="lg"
      @ok="saveQuestion"
    >
      <b-form-group label="Enunciado">
        <b-form-textarea
          v-model="questionForm.question"
          rows="3"
          required
        ></b-form-textarea>
      </b-form-group>
      <b-form-group label="Tipo">
        <b-form-select v-model="questionForm.type">
          <option value="multiple_choice">Múltipla Escolha</option>
          <option value="true_false">Verdadeiro/Falso</option>
        </b-form-select>
      </b-form-group>

      <div v-if="questionForm.type === 'multiple_choice'">
        <div v-for="(opt, i) in questionForm.options" :key="i" class="mb-2">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>{{ opt.label }}</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="opt.text"
              placeholder="Texto da opção"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :variant="opt.isCorrect ? 'success' : 'outline-secondary'"
                @click="setCorrect(i)"
              >
                <i class="fa fa-check"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <div v-else>
        <b-form-radio-group v-model="trueFalseAnswer" stacked>
          <b-form-radio value="true">Verdadeiro</b-form-radio>
          <b-form-radio value="false">Falso</b-form-radio>
        </b-form-radio-group>
      </div>

      <b-form-group label="Pontuação" class="mt-3">
        <b-form-input
          v-model.number="questionForm.points"
          type="number"
        ></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { getQuiz, updateQuiz } from "@/api/ead";

export default {
  name: "ConfigurarQuiz",
  data() {
    return {
      quizId: null,
      quiz: null,
      loading: true,
      quizForm: {
        title: "",
        description: "",
        passingScore: 70,
        timeLimit: null,
        shuffleQuestions: false,
        showResultsImmediately: true,
      },
      questions: [],
      questionModal: false,
      editingIndex: null,
      questionForm: {
        question: "",
        type: "multiple_choice",
        options: [
          { label: "A", text: "", isCorrect: false },
          { label: "B", text: "", isCorrect: false },
          { label: "C", text: "", isCorrect: false },
          { label: "D", text: "", isCorrect: false },
        ],
        points: 10,
      },
      trueFalseAnswer: "true",
      timeInMinutes: null,
    };
  },
  mounted() {
    this.quizId = this.$route.params.id;
    this.loadQuiz();
  },
  methods: {
    async loadQuiz() {
      try {
        const response = await getQuiz(this.quizId);
        this.quiz = response.data;
        this.quizForm = {
          title: this.quiz.title,
          description: this.quiz.description,
          passingScore: this.quiz.passingScore,
          timeLimit: this.quiz.timeLimit,
          shuffleQuestions: this.quiz.shuffleQuestions,
          showResultsImmediately: this.quiz.showResultsImmediately,
        };
        this.questions = this.quiz.questions || [];
        this.timeInMinutes = this.quiz.timeLimit
          ? Math.floor(this.quiz.timeLimit / 60)
          : null;
      } catch (error) {
        this.$bvToast.toast("Erro ao carregar quiz", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          autoHideDelay: 10000,
          appendToast: true,
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
    async saveQuiz() {
      try {
        await updateQuiz(this.quizId, {
          ...this.quizForm,
          timeLimit: this.timeInMinutes ? this.timeInMinutes * 60 : null,
          questions: this.questions,
        });
        this.$bvToast.toast("Quiz salvo!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          autoHideDelay: 5000,
          appendToast: true,
          solid: true,
        });
        this.loadQuiz();
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          autoHideDelay: 10000,
          appendToast: true,
          solid: true,
        });
      }
    },
    openQuestionModal(index = null) {
      this.editingIndex = index;
      if (index !== null) {
        const q = this.questions[index];
        this.questionForm = JSON.parse(JSON.stringify(q));
        if (q.type === "true_false") {
          this.trueFalseAnswer =
            q.options.find((o) => o.isCorrect).label === "A" ? "true" : "false";
        }
      } else {
        this.questionForm = {
          question: "",
          type: "multiple_choice",
          options: [
            { label: "A", text: "", isCorrect: false },
            { label: "B", text: "", isCorrect: false },
            { label: "C", text: "", isCorrect: false },
            { label: "D", text: "", isCorrect: false },
          ],
          points: 10,
        };
      }
      this.questionModal = true;
    },
    setCorrect(index) {
      this.questionForm.options.forEach((o, i) => {
        o.isCorrect = i === index;
      });
    },
    saveQuestion(evt) {
      evt.preventDefault();

      if (this.questionForm.type === "true_false") {
        this.questionForm.options = [
          {
            label: "A",
            text: "Verdadeiro",
            isCorrect: this.trueFalseAnswer === "true",
          },
          {
            label: "B",
            text: "Falso",
            isCorrect: this.trueFalseAnswer === "false",
          },
        ];
      }

      if (this.editingIndex !== null) {
        this.questions.splice(
          this.editingIndex,
          1,
          JSON.parse(JSON.stringify(this.questionForm))
        );
      } else {
        this.questions.push(JSON.parse(JSON.stringify(this.questionForm)));
      }

      this.saveQuiz();
      this.questionModal = false;
    },
    deleteQuestion(index) {
      this.questions.splice(index, 1);
      this.saveQuiz();
    },
  },
};
</script>

<style scoped>
.question-card {
  border: 1px solid #c8ced3;
  border-radius: 4px;
  padding: 1rem;
  background: #fff;
}
.question-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.question-body {
  padding-left: 2rem;
}
.option-item {
  padding: 0.25rem 0;
}
</style>
